import { render, staticRenderFns } from "./appCard.vue?vue&type=template&id=e55d9a9a&scoped=true"
import script from "./appCard.vue?vue&type=script&lang=js"
export * from "./appCard.vue?vue&type=script&lang=js"
import style0 from "./appCard.vue?vue&type=style&index=0&id=e55d9a9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e55d9a9a",
  null
  
)

export default component.exports